import { IPayerInformation } from '../../interfaces/send-payment/send-payment.interface';

export abstract class AbstractSendPaymentService {
  abstract getPayerInformation(primaryRTN: string): Promise<IPayerInformation | undefined>;
}
